<template>
  <main class="news-page">
    <section
      ref="newsFeed"
      class="news-feed"
      :class="{ '-not-found': !state.posts.length && !state.loading }"
    >
      <div class="container-2024">
        <Breadcrumbs
          class="news-page__breadcrumbs"
          :with-grid="true"
          items-class="g-col-full g-start-lg-4 g-col-lg-6"
        />

        <header v-if="state.title || state.description" class="news-feed__header grid-2024">
          <h1 v-if="state.title" class="news-feed__title h2 g-col-full g-start-lg-4 g-col-lg-6">
            {{ state.title }}
          </h1>
          <CmsContent
            v-if="state.description"
            class="news-feed__intro t1 g-col-full g-start-lg-4 g-col-lg-6"
            :html="state.description"
          />
        </header>

        <NewsSearch :search="state.search" @update="updateSearch" @reload="reload" />

        <div v-if="state.loading && !state.posts.length" class="news-feed__grid grid-2024">
          <div
            v-for="index in SKELETON_COUNT"
            :key="`news-skeleton-${index}`"
            class="card news-card -small -article -m -stretch-x -skeleton g-col-md-4 g-col-lg-3"
            :class="`-${getCardLayout(index - 1)}`"
          />
        </div>

        <div v-else-if="state.posts.length" class="news-feed__grid grid-2024">
          <NewsCard
            v-for="(post, index) in state.posts"
            :key="post.id"
            :post="post"
            :layout="getCardLayout(index)"
          />
        </div>

        <div v-else class="news-feed-not-found grid-2024">
          <div class="news-feed-not-found__content g-col-full g-start-lg-4 g-col-lg-6">
            <h2 class="news-feed-not-found__title h3">{{ t('not_found_title') }}</h2>
            <p class="news-feed-not-found__intro t2">{{ t('not_found_intro') }}</p>
          </div>
        </div>

        <Button
          v-if="isLoadMoreVisible"
          class="news-feed__load-more"
          variant="-outline"
          size="-m"
          :disabled="state.loading"
          @click="loadMore"
        >
          {{ t('more') }}
        </Button>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
  import { useI18n } from '#imports';
  import { Breadcrumbs } from '@nuxt-shared/ui/breadcrumbs';
  import { Button } from '@nuxt-shared/ui/button';
  import { CmsContent } from '@nuxt-shared/ui/cms-content';
  import { NewsCard, NewsSearch } from './ui';
  import { useNewsPageModel } from './model';

  const SKELETON_COUNT = 11;
  const { t } = useI18n({ useScope: 'local' });
  const {
    state,
    isLoadMoreVisible,
    getCardLayout,
    loadMore,
    reload,
    updateSearch,
  } = await useNewsPageModel();
</script>

<style lang="scss">
  @use './style.scss';
</style>

<i18n lang="json" src="./locale.json" />
